import React from "react";
import injectSheet from "react-jss";
import { withRouter, Redirect } from "react-router-dom";
import clsx from "clsx";
import { v4 as uuid } from "uuid";

import HotspotOptionsLightbox from "../components/HotspotOptionsLightbox";
import Player from "../../lib/player";
import ContextMenu from "../components/ContextMenu";
import ContextMenuItem from "../components/ContextMenuItem";
import { formatName } from "../utils";

const pre_width = 300;
const pre_height = 200;
// const isDescendant = (parent, child) => {
//   if (parent === child) {
//     return true;
//   }

//   let node = child.parentNode;
//   while (node !== null) {
//     if (node === parent) {
//       return true;
//     }
//     node = node.parentNode;
//   }
//   return false;
// };
// function getRotate(ratio) {
//   const delta = 0.025 / 2; // 1 / 4 / 10 / 2
//   const delta2 = (1 / 4 - delta * 4) / 2 / 2;
//   const snapping_value = [];

//   for (var i = 0; i <= 8; i++) {
//     snapping_value.push((1 / 8) * i);
//   }

//   let rotate = 0;
//   for (var i = 0; i <= 8; i++) {
//     if (Math.abs(snapping_value[i] - ratio) < delta) {
//       // in case of snapping region
//       rotate = snapping_value[i];
//       break;
//     } else if (Math.abs(snapping_value[i] + delta + delta2 - ratio) < delta2) {
//       // in case of other region
//       rotate =
//         (ratio - snapping_value[i] - delta) / 2 / delta2 / 8 +
//         snapping_value[i];
//       break;
//     }
//   }

//   return rotate;
// }

class Preview extends React.Component {
  constructor(props) {
    super(props);

    // Get the tour from the props
    const { activeImage } = this.props;

    const data = Object.assign({}, this.props.tour.data, {
      startingImage: activeImage,
    });

    const tour = Object.assign({}, this.props.tour, {
      data,
    });

    this.state = {
      tour,
      contextMenuType: "",
      currentHotspot: null,
      targetToolTip: "",
      showContextMenu: false,
      addingPinnedVideo: false,
      contextMenuPosition: {
        top: 0,
        left: 0,
      },
      contextMenuHotspot: null,
      helpText: "",
      imageName: "",
      isMounted: false,
    };
    this.onAddHotspot = this.onAddHotspot.bind(this);
    this.onHotspotSave = this.onHotspotSave.bind(this);
    this.getToolTipPosition = this.getToolTipPosition.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.tour) !== JSON.stringify(prevProps.tour)) {
      // Get the tour from the props
      const { activeImage } = this.props;

      const data = Object.assign({}, this.props.tour.data, {
        startingImage: activeImage,
      });

      this.player.config = data;

      this.setState({ tour: this.props.tour });
    }

    if (this.state.isMounted && this.props.show) {
      let rotate = this.props.rotate;
      const activeImage = this.props.tour.data.images[this.props.activeImage];
      if (activeImage.startingRotation) {
        let startingRot = activeImage.startingRotation.y;
        startingRot = (startingRot * -1) / Math.PI / 2;
        if (startingRot < 0) {
          startingRot += 1;
        }
        rotate += startingRot;
      }

      if (this.player) {
        this.player.handleMouseBorderRotate(rotate);
      }
    }

    if (prevProps.showHotSpot === false && this.props.showHotSpot === true) {
      this.onAddHotspot();
    }
  }

  componentDidMount() {
    if (!this.content) return;

    // Create player
    this.player = new Player(this.content, this.state.tour, "editor");

    this.player.onTransition = id => {
      this.props.onUpdateActiveImage(id);
    };
    this.player.onSetNodeVisibility(false);

    this.setState({ isMounted: true });
    this.onAddHotspot();
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  getImageTitle() {
    return this.props.tour.data.images[this.props.activeImage].name || '';
  }

  onSetStartingPosition() {
    const rotation = this.player.getCurrentRotation();

    const oldImage = this.props.tour.data.images[this.props.activeImage];

    const image = Object.assign({}, oldImage, {
      startingRotation: {
        x: rotation.x,
        y: rotation.y,
        z: rotation.z,
      },
    });

    this.props.onUpdateImage(image);

    window.alert(
      "Your viewpoint for this view has been set facing the direction as seen.\n\nTo reset, simply click Set Viewpoint when your view has been adjusted.",
    );
  }

  calculateOffset(startingRotation) {
    let offset = 0;
    if (startingRotation) {
      let startingRot = startingRotation.y;
      startingRot = (startingRot * -1) / Math.PI / 2;
      if (startingRot < 0) {
        startingRot += 1;
      }
      offset = startingRot;
    }

    return offset;
  }

  onAddHotspot() {
    // Choose type of hotspot
    const hotspot = {
      uuid: uuid(),
      u: 0.5,
      v: 0.5,
      type: "link",
      ratio: 0,
      options: {
        id: this.props.nodeLinkInfo.target.id,
        ratio: this.props.nodeLinkInfo.target.ratio,
        addOffset: this.props.nodeLinkInfo.target.addOffset,
        offset: this.props.nodeLinkInfo.target.offset,
        type: 1,
      },
      tooltip: "",
    };

    const images = this.props.tour.data.images;
    const image = images[this.props.activeImage];
    let tooltip = "";
    const target_id = this.props.nodeLinkInfo.target.id;

    if (target_id !== null) {
      if (images[target_id]) {
        tooltip = images[target_id].name || '';
      }
    }

    const newHotspot = {
      ...hotspot,
      tooltip,
    };

    this.setState({
      currentHotspot: newHotspot,
      targetToolTip: image.name || '',
    });
  }

  onHotspotSave() {
    const event = {
      clientX: pre_width / 2,
      clientY: pre_height / 2,
    };

    const intersect = this.player.intersectWithActivePhotoHolder(event);

    if (!intersect) return;
    const uv = { x: intersect[0].uv.x, y: 0.5 };

    // Check if this is a pinned video first

    const data = Object.assign({}, this.props.tour.data, {
      startingImage: this.props.activeImage,
    });

    const tour = Object.assign({}, this.props.tour, {
      data,
    });

    // Add hotspot to current image
    const oldImage = tour.data.images[this.props.activeImage];

    // Calculate current images' offset
    let offset = 0;
    if (oldImage.startingRotation) {
      let startingRot = oldImage.startingRotation.y;
      startingRot = (startingRot * -1) / Math.PI / 2;
      if (startingRot < 0) {
        startingRot += 1;
      }
      offset = startingRot;
    }

    // Calculate u offset from the ratio
    const target_id = this.state.currentHotspot.options.id;
    let target_old_image = null;
    const images = tour.data.images;
    for (const key in images) {
      if (images[key].id === target_id) {
        target_old_image = images[key];
        break;
      }
    }

    // Hotspot to source
    let new_hotspot = {
      ...this.state.currentHotspot,
      u: uv.x,
      v: uv.y,
      ratio: this.props.nodeLinkInfo.ratio,
      tooltip: formatName(this.state.currentHotspot.tooltip),
    };

    new_hotspot.options.offset = offset;
    new_hotspot.options.addOffset = true;

    // Calculate target images' offset

    let targetOffset = 0;
    if (target_old_image.startingRotation) {
      let startingRot = target_old_image.startingRotation.y;
      startingRot = (startingRot * -1) / Math.PI / 2;
      if (startingRot < 0) {
        startingRot += 1;
      }
      targetOffset = startingRot;
    }

    new_hotspot.options.targetOffset = targetOffset;

    const oldHotspots = oldImage.hotspots ? oldImage.hotspots : [];

    const image = Object.assign({}, oldImage, {
      hotspots: [...oldHotspots, new_hotspot],
    });

    this.props.handleShowHotSpot(false);

    this.player.sceneManager.activeScene().addHotspotFromConfig(new_hotspot);
    this.setState({ currentHotspot: new_hotspot });

    // adding boomerang
    const uuid = new_hotspot.uuid;
    const id = image.id;

    // let rotation_start = 0;
    // let rotation_target = 0;
    // if (image.startingRotation) {
    //   rotation_start = image.startingRotation.y / Math.PI / 2;
    //   // console.log("ROT START", rotation_start);
    // }

    // if (target_old_image.startingRotation) {
    //   rotation_target = target_old_image.startingRotation.y / Math.PI / 2;
    // }

    // rotation_target -= rotation_start;

    // Calculate ratio to UV value
    // console.log("ACTUAL TARGET RATIO", this.props.nodeLinkInfo.target.ratio);
    // console.log("OFFSET", offset);
    let new_u = (this.props.nodeLinkInfo.target.ratio + targetOffset) % 1;
    if (new_u > 0.5) {
      new_u = 1.5 - new_u;
    } else {
      new_u = 0.5 - new_u;
    }

    // console.log("NEW U", new_u);

    const target_hotspot = {
      ...new_hotspot,
      options: {
        ...new_hotspot.options,
        id,
        ratio: this.props.nodeLinkInfo.ratio,
        type: 0,
        targetOffset: offset,
        offset: targetOffset,
      },
      uuid,
      u: new_u,
      ratio: this.props.nodeLinkInfo.target.ratio,
      tooltip: formatName(this.state.targetToolTip),
    };
    // console.log("TARGET H", target_hotspot);
    const target_oldHotspots = target_old_image.hotspots
      ? target_old_image.hotspots
      : [];
    const target_image = Object.assign({}, target_old_image, {
      hotspots: [...target_oldHotspots, target_hotspot],
    });

    this.props.onUpdateBoomerang(image, target_image);
    this.props.clearNodeLink();
  }

  getToolTipPosition() {
    const width = 200;
    const height = 182; // from canvasImage

    const position = this.props.position;
    let top = -10;
    let left = width + 20;

    const w = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0,
    );
    const h = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0,
    );

    if (position.top < 0) {
      if (position.left > 250) {
        // toolbar width
        left = -10;
      }
      top = height + 20;
    } else if (position.top > h - pre_height - 100) {
      if (position.left > 250) {
        // toolbar width
        left = -10;
      }
      top = -pre_height - 20;
    }

    if (position.left >= w - width - pre_width - 20) {
      left = -pre_width - 20;
    }

    return { top, left };
  }

  content;
  contextMenu;
  player;

  render() {
    const { classes, activeImage, show } = this.props;

    const {
      currentHotspot,
      targetToolTip,
      contextMenuPosition,
      showContextMenu,
      contextMenuType,
    } = this.state;

    const { top, left } = this.getToolTipPosition();

    if (!activeImage) {
      return <Redirect from="/editor/:token" to="/editor/:token" />;
    }

    return (
      <div
        className={clsx(classes.container, {
          [classes.active]: show,
        })}
        style={{ position: "fixed", left, top }}
      >
        <HotspotOptionsLightbox
          show={this.props.showHotSpot}
          hotspot={currentHotspot}
          target={targetToolTip}
          images={this.state.tour.data.images}
          onClose={null}
          isBoomerang
          isNodeLink
          getOnChangeHandler={name => raw => {
            let value = raw;

            if (raw.target !== undefined) {
              value = raw.target.value;
            }

            if (name === "tooltip") {
              const hotspot = Object.assign({}, this.state.currentHotspot, {
                tooltip: value,
              });
              this.setState({ currentHotspot: hotspot });
            } else if (name === "target") {
              this.setState({ targetToolTip: value });
            }
          }}
          onComplete={this.onHotspotSave}
        />
        {showContextMenu && (
          <ContextMenu
            position={contextMenuPosition}
            ref={ref => {
              this.contextMenu = ref;
            }}
          >
            <ContextMenuItem
              onClick={() => {
                if (this.state.contextMenuHotspot._video !== undefined) {
                  this.player.sceneManager
                    .activeScene()
                    .removePinnedVideo(this.state.contextMenuHotspot);
                  this.setState({ showContextMenu: false });

                  const oldImage =
                    this.state.tour.data.images[this.props.activeImage];

                  const image = Object.assign({}, oldImage, {
                    pinnedVideos: oldImage.pinnedVideos.filter(
                      item =>
                        item.uuid !== this.state.contextMenuHotspot.getUUID(),
                    ),
                  });

                  this.props.onUpdateImage(image);
                } else {
                  this.player.sceneManager
                    .activeScene()
                    .removeHotspot(this.state.contextMenuHotspot);
                  this.setState({ showContextMenu: false });

                  const oldImage =
                    this.state.tour.data.images[this.props.activeImage];

                  const image = Object.assign({}, oldImage, {
                    hotspots: oldImage.hotspots.filter(
                      item =>
                        item.uuid !== this.state.contextMenuHotspot.getUUID(),
                    ),
                  });

                  this.props.onUpdateImage(image);
                }
              }}
            >
              Delete {contextMenuType}
            </ContextMenuItem>
          </ContextMenu>
        )}
        <div
          className={clsx(classes.mainContainer, {
            [classes.addingHotspot]: true,
          })}
          ref={content => {
            this.content = content;
          }}
        />
      </div>
    );
  }
}

const styles = {
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  container: {
    animation: "$fadein ease 0.2s",
    width: `${pre_width}px`,
    height: `${pre_height}px`,
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: -10,
    left: 200,
    visibility: "hidden",
    border: "3px solid #555",
    borderRadius: 3,
    boxShadow: "0px 0px 3px black",
    zIndex: 10,
  },
  active: {
    visibility: "visible",
  },
  mainContainer: {
    position: "relative",
    display: "flex",
    flex: 1,
    overflow: "hidden",
    backgroundColor: "#eee",
  },
  addingHotspot: {
    cursor: "crosshair",
  },
  helpText: {
    position: "absolute",
    top: 50,
    left: 0,
    width: "100%",
    textAlign: "center",
    color: "white",
    fontSize: 18,
    fontWeight: "bold",
    zIndex: 2,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "8px",
    boxSizing: "border-box",
  },
};

export default withRouter(injectSheet(styles)(Preview));
